import { PRICE_TYPES_ORDER } from '@common/ProductCard/helpers/constants';

const getActualPrice = (prices) => {
    if (!prices) {
        return null;
    }

    if (prices.sale) {
        return prices.sale.formatted_price;
    }

    const actualPriceKey = PRICE_TYPES_ORDER.find(type => prices[type]);

    if (actualPriceKey) {
        return prices[actualPriceKey].formatted_price;
    }

    return null;
};

export const prepareTrackingDataAttributes = ({
    index,
    product,
    navigationId = '',
    linkParams = {}
}) => {
    const {
        id, name, variants, brand_name: brandName, tags
    } = product ?? {};
    const bmpListingTags = tags?.bmp_listing;
    const bmpTags = tags?.bmp;
    const { prices, id: variantId } = variants?.[0] ?? [];
    const { path } = linkParams ?? {};

    return {
        'data-product-id': id,
        'data-product-name': name,
        'data-variant-id': variantId,
        'data-navigation-id': navigationId,
        'data-actual-price': getActualPrice(prices),
        'data-brand': brandName,
        'data-order': index,
        ...index && { 'data-test-id': `productCard-${index}` },
        ...path && { 'data-path': path },
        ...bmpListingTags && { 'data-tag-ids': bmpListingTags },
        ...bmpTags && { 'data-bmp-tags': bmpTags }
    };
};
